var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _polygon, _polygon2, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJet2Pak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1200.9 370.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#linear-gradient2);\n      }\n\n      .st1 {\n        fill: #fbb81b;\n      }\n\n      .st2 {\n        fill: url(#linear-gradient1);\n      }\n\n      .st3 {\n        fill: url(#linear-gradient8);\n      }\n\n      .st4 {\n        fill: url(#linear-gradient7);\n      }\n\n      .st5 {\n        fill: url(#linear-gradient4);\n      }\n\n      .st6 {\n        fill: url(#linear-gradient5);\n      }\n\n      .st7 {\n        fill: url(#linear-gradient3);\n      }\n\n      .st8 {\n        fill: #d2232a;\n      }\n\n      .st9 {\n        fill: url(#linear-gradient6);\n      }\n\n      .st10 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 460.6,
    y1: 725.4,
    x2: 460.6,
    y2: 602.2,
    gradientTransform: "translate(0 857.3) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#fbb81b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#d2232a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1",
    x1: 564,
    x2: 564,
    y2: 602.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient2",
    x1: 639.1,
    y1: 725.4,
    x2: 639.1,
    y2: 602.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient3",
    x1: 678.6,
    x2: 678.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient4",
    x1: 692,
    y1: 725.4,
    x2: 692,
    y2: 602.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient5",
    x1: 757,
    y1: 725.4,
    x2: 757,
    y2: 602.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient6",
    x1: 843.4,
    x2: 843.4,
    y2: 602.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient7",
    x1: 932.7,
    x2: 932.7,
    y2: 602.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient8",
    x1: 1013.1,
    x2: 1013.1,
    y2: 602.2,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "J",
    className: "st8",
    d: "M104.7,161.3l8.4,19.9h-3.7l-14.4-19.9s-3.9,0-5.2-.3c-.5,0-1.6,0-2.4-.3-1.3,7.8-3.1,18.3-5.2,29.8-4.4,22.2-3.9,37.9-23.2,37.9s-11.8-2.9-11.8-7.3c0-8.1,1.3-22.2,1.3-22.2H15.8s-1.6,13.6-1.6,28,14.4,30,42.3,29.8c21.4,0,35.8-5.2,48.1-22.7,6.3-8.9,9.1-29.8,14.1-52.5,1.3-6.5,2.9-13.3,4.2-19.6l-1.3-1.6-17,1h0ZM114.6,122.6c-6.3,0-13.8,1.3-18,6.3-4.2,5-6.5,14.9-7.6,20.9-.3,1.6-.5,3.4-1,5.7h6.8l14.4-19.9h3.7l-8.4,19.9,17.2,1,3.1-3.7c3.7-17,6.5-30,6.5-30,0,0-10.4-.3-16.7-.3h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "E",
    className: "st8",
    d: "M196.6,192.3l-40.8.3s3.1-20.6,23.2-20.6,17.5,20.4,17.5,20.4h0ZM178.6,152.1c-15.4.5-28,3.1-41.3,17.2-14.4,15.2-17,55.6-13.1,63.7,3.9,8.4,11,23.8,46.8,24.8,41.3,1.3,51.2-33.2,51.2-33.2h-32.7s-.3,11-17.2,11.2c-23.8.5-18.5-23.8-18.5-23.8h72.6s0-1.6,1.3-20.4c1.3-20.6-17.8-41-49.1-39.7h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "T",
    className: "st8",
    d: "M231.6,152.6l-4.7,18.5h17.8s-3.7,17.2-6.3,29.8c-2.1,9.4-7.8,33.4-3.7,42.6,3.1,6.5,11,10.4,17.2,10.7,13.1.8,28.7.5,28.7.5l4.4-24-9.7.3s-8.6.5-9.7-3.9c-2.6-9.7,9.7-55.6,9.7-55.6h22.2l3.4-18.3-21.4-.3,6.8-30s-17-.5-21.2,0c-5.5.8-9.9,7.3-12,13.3-2.4,7.3-3.9,16.7-3.9,16.7l-17.8-.3h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "_x32_",
    className: "st8",
    d: "M288.6,254.5s2.6-18.3,11.8-30.6c12.3-15.9,41.5-29,50.7-33.2,16.7-7.8,26.9-18.3,26.9-27.7s-5.2-16.5-17.8-16.5-23.2,10.4-24.6,24.6h-32.1s4.4-25.1,19.3-36.1c11.8-8.9,20.9-12.5,37.1-13.3,18.5-.8,36.1,5.7,44.1,18.5,7.6,12.3,9.9,32.4-1.6,45.2-10.2,11.2-20.6,17.2-29.8,22.7-12.3,7.3-29,15.7-33.7,18-4.2,2.1-3.4,4.2-3.4,4.2h53.6c8.1,0,12.3-3.1,12.3-3.1,0,0,3.4,11.2-2.1,18.5-2.1,2.6-7.6,8.9-17.2,8.9-9.9-.3-93.5-.3-93.5-.3h0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "h",
    className: "st10",
    d: "M484,161.8c-13.3,0-22.7,6.8-28.5,15.4h-.3l10.2-53.3c-3.9,0-15.7-.3-15.9,0-11.2-.5-14.6,13.1-14.9,13.3-.8,2.1-1.3,5-2.1,7.3l-18.5,98.2-2.4,12.5h28.5l8.1-42.1c2.1-13.6,9.1-25.1,21.2-25.1,7.8-.3,11,5.2,11,10.4s-1,9.4-1.8,13.8l-7.8,42.8h29.3l7.6-42.6c1.8-9.7,2.1-13.1,2.1-19.3,0-18-8.9-31.6-25.6-31.6Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "o",
    className: "st2",
    d: "M569.1,161.8c-32.1,0-53,21.7-53,53.8s12.3,41.8,42.8,41.8,53-16.7,53-54.9c0-23-14.9-40.8-42.8-40.8ZM561,235.2c-9.7.3-15.4-8.1-15.4-20.4s8.6-31.1,22.2-31.1,14.9,8.9,14.9,18.5c-.3,20.6-8.6,32.9-21.7,32.9Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "l",
    className: "st0",
    d: "M650.1,123.9c-11.2-.5-14.6,13.1-14.9,13.3-1.8,5.2-3.4,13.8-3.4,13.8l-2.9,15.9-16.5,88.3h28.7l24.6-131.4c-3.9,0-15.4-.3-15.7,0Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "i",
    className: "st7",
    points: "655.6 255.3 684.3 255.3 701.6 163.9 672.8 163.9 655.6 255.3"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "i-dot",
    className: "st5",
    points: "708.6 125.7 679.9 125.7 675.5 149 704.2 149 708.6 125.7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "d",
    className: "st6",
    d: "M796.7,123.9c-11.2-.5-14.6,13.1-14.9,13.3-1.8,5.2-3.4,13.8-3.4,13.8l-5.2,28v-.3h-.3c-4.2-9.9-14.1-16.7-28.5-16.7-28.2,0-41.8,28-41.8,58s13.1,37.6,30.6,37.6,22.5-6.5,29.8-16.7h.3l-2.1,14.6h26.1c.3-3.7.8-8.4,1.8-13.6l22.2-117.6c-4.7-.5-14.4-.8-14.6-.5ZM745.7,233.1c-8.9,0-13.6-7.6-13.6-18.8s8.1-28.5,21.4-28.5,13.6,9.4,13.6,18.5c.3,12.3-7.8,28.7-21.4,28.7Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "a",
    className: "st9",
    d: "M851.5,161.8c-12.8,0-21.7,2.1-30,5.2l-2.9,23c9.4-5.5,16.5-7.3,26.6-7.3s15.2,5.2,15.2,11.8,0,2.4-.3,3.7c-3.9-.3-9.7-.8-15.4-.8-25.1,0-45.2,11-45.2,33.4s9.7,26.4,27.4,26.4,21.7-4.4,27.7-14.9v-.3l.3.3-1.3,12.8h23.2c3.1-27.7,10.4-48.1,10.4-62.4-.3-22.2-16.2-30.8-35.8-30.8ZM835.9,236.2c-6,0-9.7-5-9.7-9.1,0-8.1,9.9-13.6,23.5-13.1,1.8,0,5.2,0,7.6.5-2.1,12.5-9.4,21.7-21.4,21.7Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "y",
    className: "st4",
    d: "M957.1,163.9l-28,57.7h-.3l-7.3-57.7h-29l18.3,91.2c-3.1,8.9-8.1,14.6-15.7,15.2h0c-12-.5-12-8.1-13.1-6.3-13.6,29,12,30.3,12,30.3h3.7c18.3,0,27.4-10.7,35.8-26.9l53.8-103.4h-30.3Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "s",
    className: "st3",
    d: "M1024.2,182.9c8.6,0,15.4,1.8,22.7,5l6-20.6c-10.2-3.7-20.1-5.5-27.4-5.5-19.1,0-41.5,8.6-41.5,30s34,23.5,34,36.6-11.5,8.1-15.9,8.1c-7.8,0-15.7-1.8-23-5.2l-5.7,21.7c8.9,2.9,22.2,5,34.5,4.7,21.4-.3,38.4-11.5,38.4-34.2s-35.5-22.2-35.5-32.4c.3-6.5,7.3-8.1,13.6-8.1Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "sun-7",
    className: "st1",
    d: "M999.6,101.2c4.4-4.4.5-13.1-6-22.2-6.5-8.9-16.7-9.9-21.2-5.7-4.4,4.4-3.9,14.9,5.2,21.4,8.9,6.5,17.8,11,21.9,6.5h0Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "sun-6",
    className: "st1",
    d: "M1053.2,76.1c6.3-.8,8.4-9.9,8.6-21.4.3-11-7.3-18.3-13.3-17.5-6.3.8-12,9.4-8.9,20.1,3.1,10.7,7.6,19.6,13.6,18.8h0Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "sun-5",
    className: "st1",
    d: "M1110.7,87.1c5.2,3.4,12.8-2.1,20.4-10.7,7.3-8.4,6.3-18.5,1-21.9-5.2-3.4-15.4-.5-19.9,9.7-4.4,9.9-6.8,19.6-1.6,23h0Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "sun-4",
    className: "st1",
    d: "M1149.1,128.1c2.1,5.7,11.5,6,22.7,3.9,11-2.1,16.2-11,14.1-16.7-2.1-5.7-11.8-9.9-21.7-4.4-9.7,5.2-17.2,11.2-15.2,17.2h0Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "sun-3",
    className: "st1",
    d: "M1151.9,181.1c-1.3,6,6.5,11.2,17.2,15.4,10.4,3.9,19.6-.8,20.9-6.8s-4.7-14.6-15.9-15.2c-11.2-.5-20.9.5-22.2,6.5h0Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "sun-2",
    className: "st1",
    d: "M1125,230.2c-5,3.7-2.4,12.8,3.4,22.7,5.5,9.7,15.4,12,20.4,8.1,5-3.7,5.7-14.4-2.6-21.9-8.1-7.3-16.2-12.5-21.2-8.9h0Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "sun-1",
    className: "st1",
    d: "M998.3,124.7s-3.7,6.3-1,8.1c0,0,1.3,3.9,8.6-3.7.3,0,40.5-41.8,90.6-1,0,.3,43.1,37.4,1.3,93,.3,0-5.7,5.2-3.4,8.6,0,0,2.1,4.4,10.4-2.6.8,0,65-59.3,8.6-115.5.3,0-56.9-52.2-112.9,10.2l-2.4,2.9h0Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "R",
    className: "st8",
    d: "M1060,141.7c5.7,0,10.4,4.7,10.4,10.7s-4.7,10.7-10.4,10.7-10.4-4.7-10.4-10.7c-.3-6,4.4-10.7,10.4-10.7h0ZM1060,143.5c-4.7,0-8.6,3.9-8.6,8.9s3.9,9.1,8.6,9.1,8.6-3.9,8.6-8.9c-.3-5.2-3.9-9.1-8.6-9.1h0ZM1057.9,158.7h-1.8v-11.8c1-.3,1.8-.3,3.4-.3s2.9.3,3.7.8,1,1.3,1,2.4c0,1.6-1,2.6-2.4,2.9h0c1,.3,1.8,1,2.1,2.9.3,1.8.5,2.6.8,2.9h-2.1c-.3-.3-.5-1.6-.8-3.1-.3-1.6-1-2.1-2.6-2.1h-1.3v5.5h0ZM1057.9,151.9h1.3c1.6,0,2.9-.5,2.9-2.1s-.8-2.1-2.9-2.1h-1.3v4.2Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M17.7,278h15.2c12.8,0,19.6,4.7,19.6,13.8s-6.5,14.9-18.8,14.9h-8.1l-2.4,15.7h-12.5l7.1-44.4ZM33.1,297.9c4.4,0,6.5-1.8,6.5-5.7s-2.1-5.2-6-5.2h-4.7l-1.8,11h6Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M69.9,322.4v-2.9c-3.1,2.4-6,3.7-8.9,3.7-5,0-8.6-3.7-8.6-8.6,0-7.3,6.5-11.2,19.3-11.2h.5c.3-1.3.3-2.1.3-2.6,0-1.8-1-2.9-3.1-2.9s-3.9,1-5.5,3.7l-8.9-2.1c2.6-6,7.6-8.9,14.9-8.9s13.1,3.7,13.1,8.6,0,2.4-.5,4.2l-1.8,11c-.3,1.6-.5,3.1-.5,4.2s0,2.6.3,4.2h-10.4v-.3ZM69.4,308.6c-4.2,0-6.8,2.4-6.8,5.2s1.3,2.9,3.4,2.9,2.9-.5,4.7-1.8l.8-6c-1-.3-1.6-.3-2.1-.3Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M115.6,312.8c-1.8,7.1-6.8,10.7-14.4,10.7s-14.6-6-14.6-14.9,1.3-8.4,3.7-11.5c3.4-4.2,8.1-6.5,13.3-6.5s12,4.2,12.8,11.2l-9.1.8c-.3-3.1-1.3-4.4-3.4-4.4-3.4,0-6,4.7-6,12.8s1.6,5.7,4.7,5.7,4.7-1.8,6-5.2l7.1,1.3Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M118.2,322.4l7.1-44.4h10.7l-3.9,24.6,9.9-11.2h10.4l-9.9,10.7,6.8,20.6h-11.2l-3.9-12.5-4.4,4.7-1.3,7.8h-10.2v-.3Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M168.4,322.4v-2.9c-3.1,2.4-6,3.7-8.9,3.7-5,0-8.6-3.7-8.6-8.6,0-7.3,6.5-11.2,19.3-11.2h.5c.3-1.3.3-2.1.3-2.6,0-1.8-1-2.9-3.1-2.9s-3.9,1-5.5,3.7l-8.9-2.1c2.6-6,7.6-8.9,14.9-8.9s13.1,3.7,13.1,8.6,0,2.4-.5,4.2l-1.8,11c-.3,1.6-.5,3.1-.5,4.2s0,2.6.3,4.2h-10.4v-.3ZM167.9,308.6c-4.2,0-6.8,2.4-6.8,5.2s1.3,2.9,3.4,2.9,2.9-.5,4.7-1.8l.8-6c-1-.3-1.6-.3-2.1-.3Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M214.1,291.4c-.8-.3-1.6-.3-2.4-.3s-2.4.5-3.7,1.3c3.9,1.6,5.7,4.2,5.7,7.8,0,6.3-5.5,10.4-14.6,10.4h-3.4c-1.6,0-2.6.5-2.6,1.6s1,1.6,3.4,1.6h5c8.9,0,13.1,2.1,13.1,8.9s-6.3,11-19.6,11-12.3-2.4-12.3-6,1.8-3.9,5.7-5.2c-2.9-1.6-4.2-3.1-4.2-5.2s2.1-5,6.5-7.3c-3.4-2.1-4.7-4.4-4.7-7.8,0-6.5,5.7-10.4,16.2-10.4h2.4c1.6-4.4,4.4-6.8,8.9-6.8h.8v6.5h-.3ZM190.9,325.1c0,2.4,1.6,2.9,5.2,2.9,6.8,0,9.7-.3,9.7-2.9s-2.9-2.4-8.6-2.4c-4.2-.3-6.3,0-6.3,2.4ZM196.1,301c0,2.4,1.3,3.9,3.7,3.9s4.2-1.8,4.2-4.4-1.3-3.9-3.9-3.9-3.9,1.6-3.9,4.4Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M247,315.1c-3.9,5.7-8.4,8.6-14.4,8.6-9.1,0-14.9-5.7-14.9-14.4s1.3-8.6,3.7-12c3.1-4.4,7.3-6.5,12.8-6.5,8.6,0,13.6,5.5,13.6,14.9s0,2.4-.3,3.7h-19.1v1.3c0,3.4,2.1,5.7,5.2,5.7s4.7-1.6,6.5-4.4l6.8,3.1ZM238.7,302.6c0-3.9-1.3-5.7-4.2-5.7s-5,2.1-5.7,6.3h9.9s0-.3,0-.5Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M271.3,278h10.7l-2.9,17.2c3.4-3.1,6.8-4.7,9.9-4.7,4.7,0,7.6,2.9,7.6,7.8s-.3,2.9-.5,5l-3.1,19.3h-10.4l2.9-18.8c.3-1.3.3-2.4.3-2.6,0-1.8-.8-2.9-2.4-2.9s-3.4,1.3-5.5,4.2l-3.1,20.1h-10.7l7.3-44.7Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M317,290.6c8.9,0,14.1,5.5,14.1,13.8s-6.8,19.1-17,19.1-14.1-5.2-14.1-13.6c0-12,7.1-19.3,17-19.3ZM314.7,316.2c3.4,0,5.7-5,5.7-13.3s-1.3-5-3.7-5c-3.4,0-5.7,5-5.7,13.3s1.3,5,3.7,5Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M333.2,322.4l7.1-44.4h10.7l-7.1,44.4h-10.7Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M350,322.4l5-31.3h10.7l-5,31.3h-10.7ZM355.4,287.2l1.6-9.1h10.7l-1.6,9.1h-10.7Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M396.7,322.4h-10.7l.3-2.9c-3.1,2.6-6,3.9-9.4,3.9-6,0-9.7-4.2-9.7-11.8,0-12.5,6.5-21.2,14.6-21.2s6,1,8.4,3.9l2.6-16.5h10.7l-6.8,44.4ZM385.5,297.4c-4.2,0-7.1,5.2-7.1,14.4s1.3,5,3.7,5,3.1-1,5.2-2.6l2.4-14.6c-1.3-1.3-2.9-2.1-4.2-2.1Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M420.2,322.4v-2.9c-3.1,2.4-6,3.7-8.9,3.7-5,0-8.6-3.7-8.6-8.6,0-7.3,6.5-11.2,19.3-11.2h.5c.3-1.3.3-2.1.3-2.6,0-1.8-1-2.9-3.1-2.9s-3.9,1-5.5,3.7l-8.9-2.1c2.6-6,7.6-8.9,14.9-8.9s13.1,3.7,13.1,8.6,0,2.4-.5,4.2l-1.8,11c-.3,1.6-.5,3.1-.5,4.2s0,2.6.3,4.2h-10.4v-.3ZM419.7,308.6c-4.2,0-6.8,2.4-6.8,5.2s1.3,2.9,3.4,2.9,2.9-.5,4.7-1.8l.8-6c-1-.3-1.6-.3-2.1-.3Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M434.9,325.1h1.8c4.7,0,6.8-1.3,6.8-4.4s-.3-2.1-.5-3.1l-7.3-26.1h10.7l2.9,11c.5,1.8.8,3.7,1,5.7.3-1.6,1-3.4,1.8-5.2l5.5-11.5h8.9l-15.9,32.4c-1.8,3.9-3.1,6.5-7.1,8.4-1.8.8-3.9,1.3-6.5,1.3h-2.4v-8.4h.3Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M470.1,311.7c2.4,3.4,5,5,8.4,5s3.7-1,3.7-2.4-.3-1-1-1.8c-1-1-3.4-1-6.5-2.1-4.7-1.6-7.3-5-7.3-9.4s5.5-10.4,13.1-10.4,9.9,2.4,13.3,7.3l-6,4.2c-2.6-2.9-5.5-4.4-8.1-4.4s-2.6.8-2.6,2.1c0,2.4,2.6,2.4,6.3,3.7,6.3,2.1,9.1,5,9.1,9.4s-5.5,11-14.1,11-11.5-2.4-14.9-7.3l6.8-4.7Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M509.6,325.1h1.8c4.7,0,6.8-1.3,6.8-4.4s-.3-2.1-.5-3.1l-7.3-26.1h10.7l2.9,11c.5,1.8.8,3.7,1,5.7.3-1.6,1-3.4,1.8-5.2l5.5-11.5h8.9l-15.9,32.4c-1.8,3.9-3.1,6.5-7.1,8.4-1.8.8-3.9,1.3-6.5,1.3h-2.4v-8.4h.3Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M557.4,290.6c8.9,0,14.1,5.5,14.1,13.8s-6.8,19.1-17,19.1-14.1-5.2-14.1-13.6c0-12,6.8-19.3,17-19.3ZM555,316.2c3.4,0,5.7-5,5.7-13.3s-1.3-5-3.7-5c-3.4,0-5.7,5-5.7,13.3-.3,3.4,1,5,3.7,5Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M602.6,322.4h-10.7l.5-3.7c-3.4,3.1-6.8,4.7-9.9,4.7-4.7,0-7.6-2.9-7.6-7.8s.3-2.6.5-5l3.1-19.6h10.7l-2.9,18.8c-.3,1.3-.3,2.4-.3,2.6,0,1.8.8,2.9,2.4,2.9s3.4-1.3,5.5-4.2l3.1-20.4h10.7l-5.2,31.6Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M652.7,312.8c-1.8,7.1-6.8,10.7-14.4,10.7s-14.6-6-14.6-14.9,1.3-8.4,3.7-11.5c3.4-4.2,8.1-6.5,13.3-6.5s12,4.2,12.8,11.2l-9.1.8c-.3-3.1-1.3-4.4-3.4-4.4-3.4,0-6,4.7-6,12.8s1.6,5.7,4.7,5.7,4.7-1.8,6-5.2l7.1,1.3Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M673.1,322.4v-2.9c-3.1,2.4-6,3.7-8.9,3.7-5,0-8.6-3.7-8.6-8.6,0-7.3,6.5-11.2,19.3-11.2h.5c.3-1.3.3-2.1.3-2.6,0-1.8-1-2.9-3.1-2.9s-3.9,1-5.5,3.7l-8.9-2.1c2.6-6,7.6-8.9,14.9-8.9s13.1,3.7,13.1,8.6,0,2.4-.5,4.2l-1.8,11c-.3,1.6-.5,3.1-.5,4.2s0,2.6.3,4.2h-10.4v-.3ZM672.6,308.6c-4.2,0-6.8,2.4-6.8,5.2s1.3,2.9,3.4,2.9,2.9-.5,4.7-1.8l.8-6c-1-.3-1.8-.3-2.1-.3Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M693.7,291.1h10.7l-.5,3.9c3.4-3.1,6.8-4.7,9.9-4.7,4.7,0,7.6,2.9,7.6,7.8s-.3,2.9-.5,5l-3.1,19.3h-10.7l2.9-18.8c.3-1.3.3-2.4.3-2.6,0-1.8-.8-2.9-2.4-2.9s-3.4,1.3-5.5,4.2l-3.1,20.1h-10.7l5.2-31.3Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M752.8,312.5c0,2.1,1,3.1,3.1,3.1s1.6,0,2.9-.3l-1.3,7.6c-2.6.3-5,.5-6.5.5-6.5,0-9.4-2.1-9.4-6.8s0-2.1.3-3.4l2.4-15.2h-4.4l1-7.1h4.4l2.9-10.7h9.4l-1.6,10.7h4.7l-1,7.1h-4.7l-2.1,12.8c0,.5,0,1,0,1.6Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M766.4,291.1h10.7l-.8,5.2c2.9-3.7,5.5-5.2,9.4-5.2h1l-2.1,11.2c-2.1-.8-3.4-1-4.7-1s-3.1.5-4.4,1.6l-3.1,19.6h-10.7l4.7-31.3Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M814.4,322.4h-10.7l.5-3.7c-3.4,3.1-6.8,4.7-9.9,4.7-4.7,0-7.6-2.9-7.6-7.8s.3-2.6.5-5l3.1-19.6h10.7l-2.9,18.8c-.3,1.3-.3,2.4-.3,2.6,0,1.8.8,2.9,2.4,2.9s3.4-1.3,5.5-4.2l3.1-20.4h10.7l-5.2,31.6Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M825.9,311.7c2.4,3.4,5,5,8.4,5s3.7-1,3.7-2.4-.3-1-1-1.8c-1-1-3.4-1-6.5-2.1-4.7-1.6-7.3-5-7.3-9.4s5.5-10.4,13.1-10.4,9.9,2.4,13.3,7.3l-6,4.2c-2.6-2.9-5.5-4.4-8.1-4.4s-2.6.8-2.6,2.1c0,2.4,2.6,2.4,6.3,3.7,6.3,2.1,9.1,5,9.1,9.4s-5.5,11-14.1,11-11.5-2.4-14.9-7.3l6.8-4.7Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M864.6,312.5c0,2.1,1,3.1,3.1,3.1s1.6,0,2.6-.3l-1.3,7.6c-2.6.3-5,.5-6.5.5-6.5,0-9.4-2.1-9.4-6.8s0-2.1.3-3.4l2.4-15.2h-4.4l1-7.1h4.4l2.9-10.7h9.4l-1.6,10.7h4.7l-1,7.1h-4.7l-2.1,12.8c.3.5.3,1,.3,1.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJet2Pak);
export default __webpack_public_path__ + "static/media/jet2pak.e125d6c65385ba5d03e67453214f6778.svg";
export { ForwardRef as ReactComponent };